var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSadWebpage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 188,
    viewBox: "0 0 150 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.375 3.375H3.125V184.625H146.875V40.875",
    stroke: "white",
    strokeWidth: 6.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.375 3.375L146.744 40.875H109.375V19",
    stroke: "white",
    strokeWidth: 6.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.625 109.625C65.625 104.438 69.8125 100.25 75 100.25C80.1875 100.25 84.375 104.438 84.375 109.625",
    stroke: "white",
    strokeWidth: 6.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.688 90.875C104.688 93.4375 106.813 95.5625 109.375 95.5625C111.937 95.5625 114.062 93.4375 114.062 90.875C114.062 88.3125 111.937 86.1875 109.375 86.1875C106.813 86.1875 104.688 88.3125 104.688 90.875Z",
    stroke: "white",
    strokeWidth: 6.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3125 90.875C45.3125 93.4375 43.1875 95.5625 40.625 95.5625C38.0625 95.5625 35.9375 93.4375 35.9375 90.875C35.9375 88.3125 38.0625 86.1875 40.625 86.1875C43.1875 86.1875 45.3125 88.3125 45.3125 90.875Z",
    stroke: "white",
    strokeWidth: 6.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.375 3.375H3.125V184.625H146.875V40.875",
    stroke: "white",
    strokeWidth: 6.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.375 3.375L146.744 40.875H109.375V19",
    stroke: "white",
    strokeWidth: 6.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.625 109.625C65.625 104.438 69.8125 100.25 75 100.25C80.1875 100.25 84.375 104.438 84.375 109.625",
    stroke: "white",
    strokeWidth: 6.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.688 90.875C104.688 93.4375 106.813 95.5625 109.375 95.5625C111.937 95.5625 114.062 93.4375 114.062 90.875C114.062 88.3125 111.937 86.1875 109.375 86.1875C106.813 86.1875 104.688 88.3125 104.688 90.875Z",
    stroke: "white",
    strokeWidth: 6.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3125 90.875C45.3125 93.4375 43.1875 95.5625 40.625 95.5625C38.0625 95.5625 35.9375 93.4375 35.9375 90.875C35.9375 88.3125 38.0625 86.1875 40.625 86.1875C43.1875 86.1875 45.3125 88.3125 45.3125 90.875Z",
    stroke: "white",
    strokeWidth: 6.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadWebpage);
export default __webpack_public_path__ + "static/media/sad_webpage.1a532a0b3bf435ea10516113ab41ef09.svg";
export { ForwardRef as ReactComponent };